import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ModalWrapper } from 'src/components'
import { ScanInfoCard } from '../../common/scan-info-card'
import { ScannerButton } from '../../common/scanner-button'

import { useStyles } from './styles'
import { Loader } from 'src/components/loader'

interface IProps {
  open: boolean
  handleClose: () => void
  handleProceed: () => void
  isProceeding: boolean
}

export const ProceedVerifyModal = ({ open, handleClose, handleProceed, isProceeding }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.verifyModal}>
      <ScanInfoCard
        text={t('scan-form-submit-text-2.v')}
        title={t('scan-form-submit-text.v')}
        status="error"
      />
      <div className={classes.buttonsWrapper}>
        <ScannerButton
          disabled={isProceeding}
          type="submit"
          onClick={handleProceed}
          text={
            isProceeding ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                {t('confirm-button-text.v')} <Loader size={20} isStatic />
              </Box>
            ) : (
              t('confirm-button-text.v')
            )
          }
        />
        <ScannerButton onClick={handleClose} text={t('scan-form-submit-text-1.v')} color="dark" />
      </div>
    </ModalWrapper>
  )
}
